
# Caching von Scripten ermöglichen, die per $.getScript() geladen werden
$.ajaxSetup
  cache: true
